module.exports = __webpack_public_path__ + "static/media/imperative_mood0_img.bfbf7032.JPG";